import React, { Component } from 'react';
import { BounceLoader } from 'react-spinners';
import { connect } from 'react-redux';
import { verifyEmail } from '../../redux/actions';

import './verifyEmail.css';

const mapStateToProps = (state) => ({
  errorDetail: state.verifyEmailReducer.errorDetail,
  emailVerificationFailed: state.verifyEmailReducer.emailVerificationFailed,
  emailVerificationSuccess: state.verifyEmailReducer.emailVerificationSuccess,
  statusCode: state.verifyEmailReducer.statusCode,
  isVerifying: state.verifyEmailReducer.isVerifying,
  isEmailVerified: state.verifyEmailReducer.isEmailVerified,
});

const mapDispatchToProps = { verifyEmail };

@connect(mapStateToProps, mapDispatchToProps)
class VerifyEmailView extends Component {
  componentDidMount() {
    this.props.verifyEmail();
  }

  render() {
    const { isVerifying, emailVerificationSuccess, emailVerificationFailed } = this.props;
    return (
      <div className="verify-email row justify-content-center">
        <div className="col-xl-7 col-lg-8 col-md-8 col-sm-10">
          {isVerifying && (
            <div className="loading-wrapper">
              <BounceLoader color="#084267" />
            </div>
          )}
          {!isVerifying && (emailVerificationSuccess || emailVerificationFailed) && (
            <div className="row">
              <div className="col-12 col-md-9 align-self-center">
                <h5 className="verify-email__success-title">Congrats!</h5>
                <p className="verify-email__description">Your email has been verified.</p>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default VerifyEmailView;
